<template>
    <div class="myself-message-body">
        <div class="message-content">
            <template>
                <div class="message-text">
                    <p class="message-username">{{message.fromUserName}}</p>
                    <p ref="message-content">{{message.message}}</p>
                </div>
            </template>
            <div class="message-timestamp" :style="{'justify-content': 'flex-end'}">
                <template >
                    {{ formatDate(message.timestamp) }}
                </template>
            </div>
        </div>
        <div>
            <img class="participant-thumb" :src="message.sparkMember.avatarImageSource">
        </div>
    </div>
</template>

<script>
import linkify from '@/mixins/linkify'

export default {
  props: {
    message: {
      type: Object,
      required: true
    }
  },
  mixins: [linkify]
}
</script>

<style lang="scss" scoped>

.container-message-display .myself-message-body{
    display: flex;
    align-items: flex-end;
    padding-right: 10px;
    justify-content: flex-end;

    .message-content{
        display: flex;
        align-items: flex-end;
        justify-content: flex-start;
        flex-direction: column;
        flex-grow: 1;
    }

    .participant-thumb{
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-left: 10px;
    }

    .message-timestamp {
        padding: 2px 7px;
        border-radius: 15px;
        margin: 0;
        max-width: 50%;
        overflow-wrap: break-word;
        text-align: left;
        font-size: 10px;
        color: #bdb8b8;
        width: 100%;
        display: flex;
        align-items: center;
    }

    .message-text {
        background-color: rgba(var(--color-subtle), 1);
        color: rgba(var(--color-jet), 1);
        padding: 6px 10px;
        line-height: 14px;
        border-radius: 15px;
        margin: 5px 0 5px 0;
        max-width: 70%;
        overflow-wrap: break-word;
        text-align: left;
        white-space: pre-wrap;
        border-bottom-right-radius: 0px;
        word-break: break-word;
    }
}
</style>
